import React, { Component } from "react";
import Header from "./header";
import MenuBar from "./navbar";
import Carousel from "react-bootstrap/Carousel";
import Card from "react-bootstrap/Card";
import { Button } from "react-bootstrap";
import { BASE_URL, carouselItems } from "./utility";
import { Row, Col } from "react-bootstrap";

class Home extends Component {
  state = {
    newArrivals: [
      {
        title: "Vertical Gardens",
        text: "Greenery Solutions for Indoors & Outdoors",
        href: "/verticalgarden",
        img: "download/verticalgarden/verticalgarden1",
      },
      {
        title: "Foam Panels",
        text: "Premium Quality Foam Panels",
        href: "/foampanels",
        img: "download/foampanels/foampanels1",
      },
      {
        title: "Fundermax",
        text: "Durable and Stylish Fundermax Sheets",
        href: "/fundermax",
        img: "download/fundermax/fundermax1",
      },
      {
        title: "Aluminium Louver Panels",
        text: "High-Strength Aluminium Louver Panels",
        href: "/aluminiumlouverpanels",
        img: "download/aluminiumlouverpanels/aluminiumlouverpanels2",
      },
      {
        title: "Indoor WPC Louvers",
        text: "Elegant Indoor WPC Louvers",
        href: "/indoorwpclouvers",
        img: "download/indoorwpclouvers/indoorwpclouvers1",
      },
    ],
    trending: [
      {
        title: "Wallpapers",
        text: "All kinds of imported wallpapers.",
        href: "/wallpapers",
        img: "download/wallpapers/wall1",
      },
      {
        title: "Wooden Floorings",
        text: "Best quality wooden floorings",
        href: "/woodenfloorings",
        img: "download/woodenfloorings/wood1",
      },
      {
        title: "Claddings",
        text: "All kinds of wall claddings",
        href: "/claddings",
        img: "download/claddings/cladding1",
      },
      {
        title: "Ceilings",
        text: "All kind of false ceilings",
        href: "/ceilings",
        img: "download/ceilings/ceiling1",
      },
      {
        title: "Awnings",
        text: "Wall and window Awnings",
        href: "/awnings",
        img: "download/awnings/awning1",
      },
    ],
    bestSelling: [
      {
        title: "Acoustic Baffle Ceilings",
        text: "All kinds of Acoustic Baffle Ceilings",
        href: "/acousticbaffleceilings",
        img: "download/acousticbaffleceilings/acousticbaffleceilings1",
      },
      {
        title: "Wall 2 Wall Carpets",
        text: "Imported wall-2-wall carpets",
        href: "/wall2wall",
        img: "download/wall2wallc/wall2wall1",
      },
      {
        title: "Blinds",
        text: "All kinds of blinds available (wooden blinds)",
        href: "/blinds",
        img: "download/blinds/blinds1",
      },
      {
        title: "Sun Films",
        text: "For best sun shield",
        href: "/solar",
        img: "download/solar/solar1",
      },
      {
        title: "Artificial Grass",
        text: "Lush & Realistic Artificial Grass",
        href: "/agrass",
        img: "download/agrass/agrass1",
      },
    ],
  };

  renderSection(title, items) {
    return (
      <div style={{ padding: "2rem 1rem" }}>
        <h3 style={{ color: "white", marginBottom: "1.5rem", fontSize: "1.8rem" }}>
          {title}
        </h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "1.5rem",
          }}
        >
          {items.map((item, idx) => (
            <Card
              key={idx}
              style={{
                backgroundColor: "rgba(0,0,0,0.6)",
                color: "white",
                border: "none",
                borderRadius: "15px",
                overflow: "hidden",
                transition: "transform 0.3s, box-shadow 0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.6)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.4)";
              }}
            >
              <Card.Img
                variant="top"
                src={BASE_URL + item.img}
                style={{ height: "180px", objectFit: "cover" }}
              />
              <Card.Body>
                <Card.Title>{item.title}</Card.Title>
                <Card.Text>{item.text}</Card.Text>
                <Button variant="primary" href={item.href}>
                  Explore
                </Button>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        style={{
          backgroundImage: `url(${BASE_URL + "download/general/bg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <Header />
        <MenuBar />

        <div style={{ padding: "2rem 1rem" }}>
          <Carousel>
            {carouselItems.map((item) => (
              <Carousel.Item key={item.id} interval={3000}>
                <img
                  className="d-block w-100"
                  src={item.image}
                  alt={item.caption}
                  style={{ height: "500px", objectFit: "cover", borderRadius: "25px" }}
                />
                <Carousel.Caption>
                  <h3>{item.caption}</h3>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>

        {this.renderSection("New Arrivals", this.state.newArrivals)}
        {this.renderSection("Trending", this.state.trending)}
        {this.renderSection("Best Selling", this.state.bestSelling)}

        <div style={{ padding: "2rem 1rem" }}>
              {/* Google Maps */}
          <Card
            className="mb-4 shadow-sm"
            style={{ borderRadius: "15px", backgroundColor: "rgba(255,255,255,0.95)" }}
          >
            <Card.Body>
              <Card.Title style={{ color: "#007bff" }}>Our Locations on Map</Card.Title>
              <hr />
              <Row>
                {/* Delhi Map */}
                <Col md={6} className="mb-3">
                  <Card>
                    <Card.Body>
                      <Card.Subtitle className="mb-3 text-muted">Delhi</Card.Subtitle>
                      <div style={{ borderRadius: "10px", overflow: "hidden" }}>
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.406871120986!2d77.19212631440463!3d28.52748779557965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1fef9072db3d%3A0xe831674cdc799f2e!2sRainbow%20Touch!5e0!3m2!1sen!2sin!4v1608536549039!5m2!1sen!2sin"
                          width="100%"
                          height="300"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                          title="Delhi Location"
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Bhubaneswar Map */}
                <Col md={6} className="mb-3">
                  <Card>
                    <Card.Body>
                      <Card.Subtitle className="mb-3 text-muted">Bhubaneswar</Card.Subtitle>
                      <div style={{ borderRadius: "10px", overflow: "hidden" }}>
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d935.3348710032327!2d85.84735442291706!3d20.327589520806878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1909807240fd9b%3A0xa3fe931df97f31e3!2sMancheswar%2C%20Bhubaneswar%2C%20Odisha%20751017!5e0!3m2!1sen!2sin!4v1750521477457!5m2!1sen!2sin"
                          width="100%"
                          height="300"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                          title="Bhubaneswar Location"
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default Home;
